let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
import React from "ES/lib/react";

let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../utils/FormUtils');
let ErrorAlert = require('ES/widgets/ErrorAlert');
let SlideOpenDown = require('../../widgets/SlideOpenDown');
let HorizontalFields = require('ES/widgets/HorizontalFields');
var ServicesUtils = require('ES/utils/ServicesUtils');
let AuthedUserSession = require('../../../utils/AuthedUserSession');

let QuestionnaireForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props;
    },
    getInitialValues: function (props) {
        return _.get(props, "initvals", {});
    },
    getInitialState: function () {
        // Default to HL mode if there are surveys available and no HL error
        let ghlSurveys = _.get(this.props, "config.ghl_surveys", []);
        let hl_error = _.get(this.props, "config.hl_error");
        let hasHLError = _.isString(hl_error) && !_.isEmpty(hl_error);
        let hasAvailableSurveys = _.isArray(ghlSurveys) && ghlSurveys.length > 0;
        return {
            surveyMode: (hasAvailableSurveys && !hasHLError) ? "hl" : "custom"
        };
    },
    __onModeChange: function (mode) {
        this.setState({surveyMode: mode});
    },
    buildFields: function () {
        let speaker = _.get(this, "props.speaker", null);
        let surveyMode = _.get(this, "state.surveyMode", "custom");

        // Build survey options from ghl_surveys array
        let ghlSurveys = _.get(this, "props.config.ghl_surveys", []);
        let surveyOptions = {"": "-- Select a High Level Survey --"};
        _.each(ghlSurveys, function (survey) {
            let surveyUrl = "https://hlapi.espeakers.com/widget/survey/" + survey.id;
            surveyOptions[surveyUrl] = survey.name;
        });

        let standardKey = "CLIENTPORTAL_QSNTR_ACTIONLIST_ID_0";
        let standardField = {};
        if (surveyMode === "hl") {
            standardField[standardKey] = {
                label: "Standard",
                type: "select",
                options: surveyOptions,
                validate: FormUtils.v.optional,
            };
        } else {
            standardField[standardKey] = {
                label: "Standard",
                type: "text",
                placeholder: "https://goo.gl/forms/PMK0lzlS6Z8DRE152",
                validate: FormUtils.v.optional,
            };
        }

        let fields = {};

        _.each(_.get(speaker, "todolists", []), function (list) {
            let selectKey = "clientportal_qsntr_actionlist_id_" + list.id;
            let textKey = "clientportal_qsntr_actionlist_id_" + list.id; //magic value; must match key in ClientportalController->questionnaireAction()

            if (surveyMode === "hl") {
                // Dropdown for selecting a HL survey
                fields[selectKey] = {
                    label: list.listname,
                    type: "select",
                    options: surveyOptions,
                    validate: FormUtils.v.optional,
                };
            } else {
                // Text field for custom URL
                fields[textKey] = {
                    label: list.listname,
                    type: "text",
                    placeholder: "https://goo.gl/forms/PMK0lzlS6Z8DRE152",
                    validate: FormUtils.v.optional,
                };
            }
        });

        return _.assign({}, standardField, fields);
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),

    render: function () {
        let self = this;
        let allFields = this.buildFields();
        let standardKey = "CLIENTPORTAL_QSNTR_ACTIONLIST_ID_0";
        let standardField = _.pick(allFields, [standardKey]);
        let fields = _.omit(allFields, [standardKey]);
        let errors = this.state.errors || {};
        let changes_made = this._form_areChangesMade();
        let error_msg = _.get(this.props, "error_msg");
        let success_msg = _.get(this.props, "success_msg");
        let surveyMode = _.get(this.state, "surveyMode", "custom");
        let hl_error = _.get(this.props, "config.hl_error");
        let hasHLError = _.isString(hl_error) && !_.isEmpty(hl_error);
        let needsUpgrade = hl_error === "Your HighLevel CRM connection does not support surveys" ||
            (_.isString(hl_error) && hl_error.indexOf("To use integrated features") === 0);

        return <form className='form-horizontal' onSubmit={this._form_onSubmit}>
            <h3>Pre-event Questionnaire</h3>
            {needsUpgrade &&
                <div className="alert alert-info">
                    <h4><i className="fa fa-info-circle" /> HighLevel CRM Surveys Now Available</h4>
                    <p>
                        You can now use HighLevel CRM Surveys for your pre-event questionnaire instead of Google Forms.
                    </p>
                    <p>
                        <a target={'_blank'} href={'/dashboard/token-callback?token=' + _.get(AuthedUserSession, ['balboa', 'estoken'], '') + '&redir=/high-level'} className="btn btn-primary">
                            Update Now <i className="fa fa-external-link" />
                        </a>
                    </p>
                </div>
            }
            {hasHLError && !needsUpgrade &&
                <div className="alert alert-warning">
                    <i className="fa fa-exclamation-triangle" /> We were unable to find your HighLevel CRM surveys: {hl_error}
                </div>
            }
            <p>
                Select a High Level Survey, or enter the URL to the Google Form for your pre-event questionnaire. You can assign a specific Form to events using specific Action Lists. The STANDARD form will be used if there is not a specific one assigned to an event.
            </p>
            <p>
                <a href="https://espeakers.com/wiki/Pre-event_Questionnaire_in_the_Client_Portal" target="_blank">
                    Learn more about pre-event questionnaires <i style={{marginLeft: "0.5em", fontSize: "1.0em"}} className="fa fa-external-link"/>
                </a>
            </p>
            {!hasHLError &&
                <div className="form-group">
                    <label className="col-sm-3 control-label">Questionnaire Type</label>
                    <div className="col-sm-9">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="surveyMode"
                                value="hl"
                                checked={surveyMode === "hl"}
                                onChange={function () { self.__onModeChange("hl"); }}
                            />
                            High Level Surveys
                        </label>
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="surveyMode"
                                value="custom"
                                checked={surveyMode === "custom"}
                                onChange={function () { self.__onModeChange("custom"); }}
                            />
                            Custom Link
                        </label>
                    </div>
                </div>
            }
            <div style={{marginBottom: "1.5em", paddingBottom: "0.5em", borderBottom: "1px solid #ddd"}}>
                {HorizontalFields({
                    fields: standardField,
                    errors: errors,
                    buildInput: this._form_buildInput
                })}
            </div>
            {HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            })}
            {SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
            }
            {success_msg && !changes_made &&
            <div className="alert alert-success">
                Saved.
            </div>}
            {ErrorAlert({
                message: error_msg
            })}

        </form>;
    }
});

module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_questionnaire")],

    getInitialState: function () {
        return {
            sid: -1,
            data: {},
            is_saving: false,
            error_msg: null,
            success_msg: null
        };
    },
    componentWillReceiveProps(props) {
        _.set(props, "config.questionnaire.sid", _.get(props, "config.sid"));
        this.setState({sid: props.config.sid, config: props.config, data: props.config.questionnaire, success_msg: null, error_msg: null});
    },
    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into QuestionnaireForm() as a parameter
    __onSubmit: function (data) {
        let self = this;
        radio('save_ClientPortal_questionnaire').broadcast(data.sid, data,
            function (sid, data) {
                if (_.get(self, "state.data.sid") == sid) {
                    self.setState({
                        sid: sid,
                        config: data,
                        data: _.get(data, "questionnaire"),
                        is_saving: false,
                        error_msg: null,
                        success_msg: "Saved."
                    });
                }
            },
            function (sid, message) {
                self.setState({error_msg: message, success_msg: null});
            });
    },
    __selectTextInput: function (e) {
        e.target.setSelectionRange(0, e.target.value.length);
    },
    render: function () {
        let {speaker, Displaylists} = this.props;

        return dd.div({},
            QuestionnaireForm({
                speaker,
                Displaylists,
                config: _.get(this, "state.config"),
                initvals: this.state.data,
                onSubmit: this.__onSubmit,
                error_msg: _.get(this.state, "error_msg"),
                success_msg: _.get(this.state, "success_msg")
            })
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/ClientPortal/QuestionnaireForm.js